import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, Button, ButtonBase, Typography } from '@mui/material';

// project imports
import ProfileSection from './ProfileSection';

// assets
import { IconMenu2 } from '@tabler/icons';
import LogoSection from '../LogoSection';
import NotificationSection from './NotificationSection';
import LogoutButton from './LogoutButton';
import LanguageSwitcher from 'views/switchLanguage/LanguageSwitcher';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {
  const theme = useTheme();

  const hotel = JSON.parse(localStorage.getItem('hotelData'));
  console.log("in in header section hotel===>",hotel);

  return (
    <>
      {/* logo & toggler button */}
      <Box
        sx={{
          width: 228,
          display: 'flex',
          [theme.breakpoints.down('md')]: {
            width: 'auto'
          }
        }}
      >
        <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
          <LogoSection />
        </Box>
        <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              transition: 'all .2s ease-in-out',
              background: theme.palette.secondary.light,
              color: theme.palette.secondary.dark,
              '&:hover': {
                background: theme.palette.secondary.dark,
                color: theme.palette.secondary.light
              }
            }}
            onClick={handleLeftDrawerToggle}
            color="inherit"
          >
            <IconMenu2 stroke={1.5} size="1.3rem" />
          </Avatar>
        </ButtonBase>
      </Box>
      {
        hotel.role === 'HotelAdmin' ?
        (<Typography variant="h3" sx={{mx: 2, color: '#2C69D1'}}> Welcome to Hotel {hotel.name}</Typography>): 
        hotel.role === 'admin' ?
        (<Typography variant="h3" sx={{mx: 2, color: '#2C69D1'}}> Welcome, Admin {hotel.firstName} {hotel.lastName} </Typography>) :
        (<Typography variant="h3" sx={{mx: 2, color: '#2C69D1'}}> Welcome, {hotel.firstName} {hotel.lastName} </Typography>)
      }
      
      

      {/* header search */}
      {/* <SearchSection /> */}
      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />
      {/* notification & profile */}
      <ProfileSection />
      <LogoutButton/>
      <LanguageSwitcher/>
      {/* <Button variant="contained" sx={{mx : 2}} > Logout </Button> */}
    </>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func
};

export default Header;
